import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

export default function Terms() {
  return (
    <div className="home legal-page">
      <Navbar />

      <div className="customer-page legal-content-wrap">
        <div className="customer-page-header legal-hero">
          <h2>Terms & Conditions</h2>
          <p>Last Updated: March 2026</p>
        </div>

        <section className="customer-card settings-section legal-section">
          <h3>1. Acceptance of Terms</h3>
          <p>
            By accessing and using the Shreeji Surti Swad platform and services, you accept and agree to be bound by 
            the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>2. Use License</h3>
          <p>
            Permission is granted to temporarily download one copy of the materials (information or software) on Shreeji 
            Surti Swad for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, 
            and under this license you may not:
          </p>
          <ul className="legal-list">
            <li>Modifying or copying the materials</li>
            <li>Using the materials for any commercial purpose or for any public display</li>
            <li>Attempting to decompile or reverse engineer any software</li>
            <li>Removing any copyright or proprietary notations</li>
            <li>Transferring the materials to another person</li>
          </ul>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>3. Disclaimer</h3>
          <p>
            The materials on Shreeji Surti Swad are provided on an 'as is' basis. Shreeji Surti Swad makes no warranties, 
            expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, 
            implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>4. Limitations</h3>
          <p>
            In no event shall Shreeji Surti Swad or its suppliers be liable for any damages (including, without limitation, 
            damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use 
            the materials on the website.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>5. Accuracy of Materials</h3>
          <p>
            The materials appearing on Shreeji Surti Swad could include technical, typographical, or photographic errors. 
            Shreeji Surti Swad does not warrant that any of the materials on our website are accurate, complete, or current. 
            We may make changes to the materials contained on the website at any time without notice.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>6. Links</h3>
          <p>
            Shreeji Surti Swad has not reviewed all of the sites linked to its website and is not responsible for the contents 
            of any such linked site. The inclusion of any link does not imply endorsement by Shreeji Surti Swad of the site. 
            Use of any such linked website is at the user's own risk.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>7. Modifications</h3>
          <p>
            Shreeji Surti Swad may revise these terms of service for the website at any time without notice. By using this website, 
            you are agreeing to be bound by the then current version of these terms of service.
          </p>
        </section>

        <section className="customer-card settings-section legal-section">
          <h3>8. Governing Law</h3>
          <p>
            These terms and conditions are governed by and construed in accordance with the laws of India, 
            and you irrevocably submit to the exclusive jurisdiction of the courts in that location.
          </p>
        </section>
      </div>

      <Footer />
    </div>
  );
}
